import React from "react";

import { Typography } from "@mui/material";
import { Stack } from "@mui/material";
import { PsychologyReverse } from "assets/material-custom-icons";

interface AIQuestionTextProps {
  question: string;
}

export const AIQuestionText: React.FC<AIQuestionTextProps> = ({ question }) => {
  return (
    <Stack flexDirection="row" gap="15px" alignItems="center" justifyContent="flex-start">
      <PsychologyReverse fontSize="md" sx={{ fill: "#496682" }} />
      <Typography fontStyle="italic" sx={{ backgroundColor: "white" }}>
        {question}
      </Typography>
    </Stack>
  );
};
